module.exports = __webpack_public_path__ + "static/media/shield_led-matrix-green.087e33a2.svg";